<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择订单明细"
      class="customer-edit"
      width="80%"
      top="5vh">
    <div class="salesOrder">
      <template>
        <div style="width: 100%;">
          <div
              style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; margin: 5px 0">
            <div>
              <el-button plain :style="buttonStyle" @click="newTime"> 2020年1月1日以后</el-button>
              <el-button plain :style="buttonStyle1" @click="oldTime"> 更早</el-button>
            </div>
            <div>
              <el-button
                  type="primary"
                  class="adSearchShow"
                  style="background: none; border: none; color: #2d8cf0"
                  :icon="adSearchShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                  @click="adSearchShow = !adSearchShow">
                {{adSearchShow ? "收起" : "展开"}}
              </el-button>
            </div>
          </div>
          <div v-if="adSearchShow" class="sousuo">
            <div class="sousuo-nr">
              <vm-search label="订单编号">
                <el-input
                    v-model.trim="filter.salesOrderNO"
                    type="textarea"
                    autosize
                    style="width: 150px"
                    clearable/>
              </vm-search>
              <vm-search label="SAP订单号">
                <el-input v-model.trim="filter.sAPSalesOrderNO" style="width: 150px" clearable/>
              </vm-search>
              <vm-search label="客户名称">
                <el-input v-model.trim="filter.customerName" style="width: 150px" clearable/>
              </vm-search>
              <vm-search label="客户合同号">
                <el-input v-model.trim="filter.clientContractNO" style="width: 150px" clearable/>
              </vm-search>
              <vm-search label="项目名称">
                <el-input v-model.trim="filter.projectName" style="width: 150px" clearable/>
              </vm-search>
              <vm-search label="状态">
                <el-select v-model.trim="filter.status" style="width: 150px" clearable placeholder="请选择">
                  <el-option
                      v-for="item in constant.toSelect(constant.salesStatus)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </vm-search>
            </div>
            <div class="ad-search-btn">
              <el-button
                  type="primary"
                  size="mini"
                  style="height: 26px; padding: 0 10px"
                  @click="changeSalesOrders">
                确认
              </el-button>
              <div>
                <el-button
                    plain
                    type="primary"
                    size="mini"
                    style="height: 26px; padding: 0 10px"
                    @click="handleClearClick">
                  重置
                </el-button>
                <el-button
                    :loading="loading"
                    type="primary"
                    size="mini"
                    style="height: 26px; padding: 0 10px"
                    @click="handleSearchClick">
                  查询
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <el-table
          v-loading="loading"
          :data="tableData"
          height="60vh"
          :default-expand-all="true"
          style="width: 100%"
          @expand-change="handleExpandChange">
        <el-table-column fixed="left" type="expand">
          <template slot-scope="props">
            <el-table
                :ref="`innerTable_${props.$index}`"
                :data="props.row.salesOrderSAPMaterialVOes"
                style="width: 100%;margin: 0 auto"
                row-key="id"
                @select="(selection, row) => select(selection, props.row)"
                @select-all="(selection) => select(selection, props.row)">
              <el-table-column type="selection" align="center" width="45" :reserve-selection="true"/>
              <el-table-column align="center" width="100px" prop="materialNO" label="物料号">
                <template slot-scope="scope">
                  <span
                      v-if="scope.row.sapProductionOrder !== null"
                      style="cursor: pointer;color: #2D8CF0"
                      @click="$refs.materialDetails.open(scope.row.sapProductionOrder.pkid)">{{scope.row.materialNO}}</span>
                  <span v-else>{{scope.row.materialNO}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="materialName" label="物料描述"/>
              <el-table-column align="center" prop="quantity" label="数量" width="80px"/>
              <el-table-column align="center" prop="unit" label="单位" width="80px"/>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="salesOrderNO" align="center" width="100" label="编号"/>
        <el-table-column prop="projectName" align="center" label="项目名称" min-width="240"/>
        <el-table-column prop="customerName" align="center" label="客户" min-width="200"/>
        <el-table-column
            prop="creatorName"
            align="center"
            width="120"
            label="创建者"
            show-overflow-tooltip/>
        <el-table-column prop="finalDeliveryDate" align="center" width="135" label="计划调整交期"/>
        <el-table-column prop="sapsalesOrderNO" align="center" width="100" label="SAP订单号"/>
        <el-table-column prop="clientContractNO" align="center" label="客户合同号" width="120"/>
        <!--        <el-table-column prop="deliveryDate" align="center" width="90" label="计划交期"/>-->
        <!--        <el-table-column prop="orderType" align="center" width="70" label="订单类型"/>-->
        <!--      <el-table-column prop="totalMoney" align="center" width="90" label="总金额"/>-->
        <!--        <el-table-column prop="submitTime" align="center" width="135" label="提交时间"/>-->
        <!--        <el-table-column prop="status" align="center" width="100" label="状态">-->
        <!--          <template slot-scope="scope">-->
        <!--            {{constant.salesStatus[scope.row.status]}}-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column prop="deliveryStatusName" align="center" width="70" label="发货状态"/>
      </el-table>
      <div style="margin-top: 16px; overflow: hidden; color: #000">
        <el-pagination
            class="page"
            :page-sizes="[10, 50, 100, 200, 300, 500]"
            :page-size.sync="pageSize"
            :current-page="currentPage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="changePage"/>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import VmSearch from "@/components/VmSearch";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";

  export default {
    name: "SalesOrderSelect",
    components: {VmSearch},
    data() {
      return {
        constant,
        submitDate: [],
        dialogVisible: false,
        exportExcelLoading: false,
        KrTKEImportLoading: false,
        IndTKEImportLoading: false,
        priceImportLoading: false,
        yiXinApplicationDialog: false,
        DsExportVisible: false,
        SelectFileDialog: false,
        exportLoading: false,
        uploadLoading: false,
        isBtn: true,
        isBtn1: false,
        visible: false,
        customerName: "",
        fileName: "",
        adSearchShow: true,
        loading: false,
        fileList: [],
        pickerOptions: {
          disabledDate: (time) => {
            return this.dealDisabledDate(time);
          },
        },
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        idList: "",
        filter: {
          filter: "",
          timeSegment: 2020,
          contractAttachment: 0,
          salesOrderNO: "",
          sAPSalesOrderNO: "",
          customerName: "",
          clientContractNO: "",
          projectName: "",
          creatorName: "",
          status: "",
          priority: "",
          includeControlBox: -1,
          keyMaterial: "",
          productType: -1,
        },
        currentPage: 1,
        pageSize: 10,
        total: 0,
        params: {
          unpaidTaxtMoney: "",
          taxIncludedMoney: "",
          strDate: "",
          editDate: "",
        },
        tableData: [],
        ids: [],
        selection: [],
        salesOrderList: {},
        ruleValidate: {},
      };
    },
    computed: {
      buttonStyle: function() {
        return {
          color: this.isBtn ? "#2D8CF0" : "#000",
          background: "none",
          border: "none",
        };
      },
      buttonStyle1: function() {
        return {
          color: this.isBtn1 ? "#2D8CF0" : "#000",
          background: "none",
          border: "none",
        };
      },
    },
    methods: {
      open() {
        this.dialogVisible = true;
        // this.$nextTick(() => {
        //   this.getList(1);
        // });
      },
      getList(pageIndex) {
        this.currentPage = pageIndex;
        this.loading = true;
        let params = Object.assign({pageSize: this.pageSize, pageNum: pageIndex}, this.filter);
        this.$http
          .post("basic", "sd/so/getSelectPageList", params)
          .then((res) => {
            this.loading = false;
            this.tableData = res.records;
            this.total = res.total;
          })
          .catch(() => {
            this.loading = false;
            this.$message.error("获取失败");
          });
      },
      handleExpandChange(row, expanded) {
        if (expanded) {
          this.$nextTick(() => {
            // 找到对应的内层表格
            const rowIndex = this.tableData.indexOf(row);
            const tableRef = this.$refs[`innerTable_${rowIndex}`];
            if (tableRef && this.salesOrderList[row.salesOrderNO]) {
              // 遍历明细项，设置选中状态
              row.salesOrderSAPMaterialVOes.forEach(item => {
                const isSelected = this.salesOrderList[row.salesOrderNO].includes(item);
                tableRef.toggleRowSelection(item, isSelected);
              });
            }
          });
        }
      },
      select(selection, row) {
        // 保存选中状态到每个明细项
        row.salesOrderSAPMaterialVOes.forEach(item => {
          item.selected = selection.includes(item);
        });
        // 更新选中列表 - 按照
        this.salesOrderList[row.salesOrderNO] = selection;
      },
      renderHeader(h, {column}) {
        return h("span", [
          h("span", column.label),
          h("i", {
            class: "el-icon-paperclip",
            style: "color:#444444; font-size: 16px;",
          }),
        ]);
      },
      handleSearchClick() {
        this.getList(1);
      },
      changeSalesOrders() {
        const selectOrderList = [];
        for (let key in this.salesOrderList) {
          selectOrderList.push(...this.salesOrderList[key]);
        }
        this.$emit("select", selectOrderList);
        // 清空所有表格的选中状态
        this.clearSelection();
        this.dialogVisible = false;
      },
      clearSelection() {
        // 遍历所有内层表格并清空选中状态
        for (let i = 0; i < this.tableData.length; i++) {
          const tableRef = this.$refs[`innerTable_${i}`];
          if (tableRef) {
            tableRef.clearSelection();
          }
        }
        // 清空选中列表
        this.salesOrderList = {};
      },
      handleClearClick() {
        this.filter.filter = "";
        this.filter.salesOrderNO = "";
        this.filter.sAPSalesOrderNO = "";
        this.filter.customerName = "";
        this.filter.clientContractNO = "";
        this.filter.projectName = "";
        this.filter.creatorName = "";
        this.filter.status = "";
        this.filter.priority = "";
        this.filter.includeControlBox = "";
        this.filter.keyMaterial = "";
        this.filter.timeSegment = 2020;
        this.isBtn = true;
        this.isBtn1 = false;
        // 清空选中状态
        this.clearSelection();
        this.$nextTick(() => {
          this.getList(1);
        });
      },
      // 供外部调用的清空选择方法
      resetSelection() {
        this.clearSelection();
      },
      onProgress() {
        this.BatchTimeLoading = true;
        this.disabled = true;
      },

      handleRemove(file, fileList) {
        console.log(file, fileList);
      },

      fileChange(file, fileList) {
        this.fileList = fileList;
      },

      dialogClose() {
        this.$refs.form.resetFields();
        this.submitLoading = false;
      },

      changePage(pageIndex) {
        this.getList(pageIndex);
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getList(1);
      },

      //韩国蒂森订单导入
      KrTKEImport(params) {
        this.KrTKEImportLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "sd/so/praseKrTKESalesOrder", formData)
          .then((res) => {
            if (res.success) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "success",
              });
              this.getList(1);
            } else {
              this.$message.error(res.message);
            }
            this.KrTKEImportLoading = false;
          })
          .catch(() => {
            this.KrTKEImportLoading = false;
          });
      },

      //印度蒂森订单导入
      IndTKEImport(params) {
        this.IndTKEImportLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "sd/so/IndTKESaleOrderImport", formData)
          .then((res) => {
            if (res.success) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "success",
              });
              this.getList(1);
            } else {
              this.$message.error(res.message);
            }
            this.IndTKEImportLoading = false;
          })
          .catch(() => {
            this.IndTKEImportLoading = false;
          });
      },

      //韩国蒂森价格导入
      priceImport(params) {
        this.$confirm("批量修改数据会影响日常业务，请在下班后执行", "提示", {type: "warning"}).then(() => {
          this.priceImportLoading = true;
          let formData = new FormData(); //  用FormData存放上传文件
          formData.append("file", params.file);
          formData.append("Authorization", loginUtil.getToken());
          this.$http
            .post("basic", "sd/so/tk/sapSalesOrderPrice", formData)
            .then((res) => {
              if (res.success) {
                this.$message({
                  showClose: true,
                  message: res.data,
                  type: "success",
                });
                this.getList(1);
              } else {
                this.$message.error(res.message);
              }
              this.priceImportLoading = false;
            })
            .catch(() => {
              this.priceImportLoading = false;
            });
        });
      },
      uploadFile(file) {
        console.log("upload", file);
      },

      priceImportGuangri(params) {
        this.$confirm("批量修改数据会影响日常业务，请在下班后执行", "提示", {type: "warning"}).then(() => {
          this.priceImportLoading = true;
          let formData = new FormData(); //  用FormData存放上传文件
          formData.append("file", params.file);
          formData.append("Authorization", loginUtil.getToken());
          this.$http
            .post("basic", "sd/so/guangri/sapSalesOrderPrice", formData)
            .then((res) => {
              if (res.success) {
                this.$message({
                  showClose: true,
                  message: res.data,
                  type: "success",
                });
                this.getList(1);
              } else {
                this.$message.error(res.message);
              }
              this.priceImportLoading = false;
            })
            .catch(() => {
              this.priceImportLoading = false;
            });
        });
      },

      priceImportLingWang(params) {
        this.$confirm("批量修改数据会影响日常业务，请在下班后执行", "提示", {type: "warning"}).then(() => {
          this.priceImportLoading = true;
          let formData = new FormData(); //  用FormData存放上传文件
          formData.append("file", params.file);
          formData.append("Authorization", loginUtil.getToken());
          this.$http
            .post("basic", "sd/so/lingwang/sapSalesOrderPrice", formData)
            .then((res) => {
              if (res.success) {
                this.$message({
                  showClose: true,
                  message: res.data,
                  type: "success",
                });
                this.getList(1);
              } else {
                this.$message.error(res.message);
              }
              this.priceImportLoading = false;
            })
            .catch(() => {
              this.priceImportLoading = false;
            });
        });
      },

      priceImportAoDiSi(params) {
        this.$confirm("批量修改数据会影响日常业务，请在下班后执行", "提示", {type: "warning"}).then(() => {
          this.priceImportLoading = true;
          let formData = new FormData(); //  用FormData存放上传文件
          formData.append("file", params.file);
          formData.append("Authorization", loginUtil.getToken());
          this.$http
            .post("basic", "sd/so/aodisi/sapSalesOrderPrice", formData)
            .then((res) => {
              if (res.success) {
                this.$message({
                  showClose: true,
                  message: res.data,
                  type: "success",
                });
                this.getList(1);
              } else {
                this.$message.error(res.message);
              }
              this.priceImportLoading = false;
            })
            .catch(() => {
              this.priceImportLoading = false;
            });
        });
      },

      //蒂森井道数据导出
      DsDataExport() {
        this.exportLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        this.fileList.forEach(item => {
          formData.append("files", item.raw);
        });
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .postForFile("basic", "sd/so/krTKEShaftData", formData)
          .then((res) => {
            let blob = new Blob([res.data]);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, "蒂森井道数据.zip");
            } else {
              let a = document.createElement("a");
              a.href = window.URL.createObjectURL(blob);
              a.download = "蒂森井道数据.zip";
              a.click();
              window.URL.revokeObjectURL(a.href);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      handleChange() {
        this.getList(1);
      },
      selectOne(selection) {
        this.ids = [];
        this.selection = [];
        this.selection = selection;
        console.log("selection", selection);
        for (let item of selection) {
          this.ids.push(item.pkid);
        }
      },
      selectAll(selection) {
        this.ids = [];
        this.selection = [];
        this.selection = selection;
        console.log("selection", selection);
        for (let item of selection) {
          this.ids.push(item.pkid);
        }
      },
      deleteRow(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic", "/products", row.pkid).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
      //导出
      exportExcel(dataType) {
        let url = "";
        if (dataType === 1) {
          url = "sd/so/exportTechParamBill";
        } else if (dataType === 2) {
          url = "sd/so/exportProductionDetail";
        }
        this.exportExcelLoading = true;
        this.$http
          .exportFile("basic", url, this.filter)
          .then((res) => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportExcelLoading = false;
          })
          .catch(() => {
            this.exportExcelLoading = false;
          });
      },
      // 获取当前时间
      getFormatDate(date) {
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate;
      },
      dealDisabledDate(time) {
        if (this.isBtn) {
          return time.getTime() < new Date("2019-12-31").getTime();
        } else {
          return time.getTime() > new Date("2019-12-31").getTime();
        }
      },
      newTime() {
        this.isBtn1 = false;
        this.isBtn = !this.isBtn;
        this.filter.timeSegment = 2020;
        this.filter.endSubmitTime = this.getFormatDate(new Date());
        this.filter.beginSubmitTime = this.getFormatDate(new Date(new Date() - 3600 * 1000 * 24 * 29));
        // this.submitDate = [];
        // this.submitDate.push(this.filter.beginSubmitTime);
        // this.submitDate.push(this.filter.endSubmitTime);
        // this.getList(1);
      },
      oldTime() {
        this.isBtn = false;
        this.isBtn1 = !this.isBtn1;
        this.filter.timeSegment = 2019;
        this.filter.beginSubmitTime = "2019-01-01";
        this.filter.endSubmitTime = "2019-12-31";
        // this.submitDate = [];
        // this.submitDate.push(this.filter.beginSubmitTime);
        // this.submitDate.push(this.filter.endSubmitTime);
        // this.getList(1);
      },
      dateCompare(date1, date2) {
        let time1 = date1.replace(/-/g, "");
        let time2 = date2.replace(/-/g, "");
        if (time1 <= time2) {
          return true;
        } else {
          return false;
        }
      },

      onUploadChange(file) {
        this.fileList[0] = file;
        this.fileName = file.name;
      },

      submitUpload() {
        if (this.customerName === "") {
          this.$message.error("请先选择客户！");
        }
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", this.fileList[0].raw);
        formData.append("name", this.fileList[0].name);
        if (this.customerName === "韩国蒂森订单") {
          this.url = "sd/so/praseKrTKESalesOrder";
        } else if (this.customerName === "印度蒂森STO控制柜") {
          this.url = "sd/so/IndTKESaleOrderImport";
        } else if (this.customerName === "印度蒂森散件") {
          this.url = "sd/so/IndTKEPartsSaleOrderImport";
        } else if (this.customerName === "进口蒂森控制柜") {
          this.url = "sd/so/importTKESalesOrder";
        }

        this.$http
          .post("basic", this.url, formData)
          .then((res) => {
            if (res.success) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "success",
              });
              this.getList(1);
            } else {
              this.$message.error(res.message);
            }
            this.uploadLoading = false;
          })
          .catch(() => {
            this.uploadLoading = false;
          });

      },

      selectCustomerName(row) {
        this.customerName = row.customerName;
      },
    },
  };
</script>

<style lang="scss" scoped>
.salesOrder {
  .vm-page-table .ad-search .ad-search_content .ad-search-btn {
    height: 28px;
  }

  .el-select {
    width: 150px !important;
  }

  .el-radio__label {
    font-size: 12px !important;
  }

  .el-radio {
    margin-right: 5px !important;
  }

  .el-radio__label {
    padding-right: 5px !important;
    padding-left: 5px !important;
  }

  .vm-page-table .ad-search .ad-search_content {
    padding: 0 !important;
    width: 100%;
  }

  .vm-page-table .ad-search .ad-search_content .ad-search-btn {
    bottom: 2px;
  }

  .el-pagination {
    text-align: right;
  }

  .sousuo {
    width: 100%;
    background: #f4f7fa;
    /*margin-top: 10px;*/
    margin-bottom: 10px;
    border-top: 1px dashed #cccccc;

    .sousuo-nr {
      padding: 10px 10px 8px 10px;

      .vm-search-com .vm-search-label[data-v-658ba3ef] {
        width: 80px !important;
        font-size: 12px !important;
      }

      .zhi {
        width: 180px !important;
      }
    }

    .ad-search-btn {
      text-align: left;
      margin: 10px 0 0 20px;
      padding-bottom: 5px;
      display: flex;
      justify-content: space-between;
    }
  }

  .date-display {
    display: inline-block;
  }

  .radiobg {
    background: #eaf4fe;
    padding: 5px;
    border: 1px solid #e6e6e6;
    font-size: 12px !important;

    .el-radio__label {
      font-size: 12px !important
    }
  }
}
</style>
